module.exports = __webpack_public_path__ + "img/cube.55b75f02.svg";